// Persistent countdown timer with warnings and auto-submit
import React, { useEffect, useRef, useState } from 'react';
import { useExam } from './ExamContext';

const WARNING_THRESHOLD = 5 * 60; // 5 minutes in seconds

const Timer = ({ onAutoSubmit }) => {
  const { state, dispatch } = useExam();
  const { timer, status } = state;
  const [warning, setWarning] = useState(false);
  const intervalRef = useRef();

  useEffect(() => {
    if (status !== 'in-progress') return;
    intervalRef.current = setInterval(() => {
      dispatch({ type: 'SET_TIMER', payload: Math.max(0, state.timer - 1) });
    }, 1000);
    return () => clearInterval(intervalRef.current);
    // eslint-disable-next-line
  }, [status]);

  useEffect(() => {
    if (timer <= WARNING_THRESHOLD) setWarning(true);
    else setWarning(false);
    if (timer === 0 && status === 'in-progress') {
      dispatch({ type: 'SET_STATUS', payload: 'submitted' });
      if (onAutoSubmit) onAutoSubmit();
    }
    // eslint-disable-next-line
  }, [timer, status]);

  // Format seconds as HH:MM:SS
  const formatTime = (secs) => {
    const h = Math.floor(secs / 3600);
    const m = Math.floor((secs % 3600) / 60);
    const s = secs % 60;
    return [h, m, s]
      .map((v, i) => (i === 0 && v === 0 ? null : String(v).padStart(2, '0')))
      .filter(Boolean)
      .join(':');
  };

  return (
    <div
      className="exam-timer"
      style={{
        fontWeight: 700,
        fontSize: 22,
        color: warning ? '#dc2626' : '#059669',
        letterSpacing: 1,
        padding: 8,
        borderRadius: 6,
        background: warning ? '#fef2f2' : '#f0fdf4',
        display: 'inline-block',
        minWidth: 100,
      }}
      aria-label="Exam Timer"
    >
      {formatTime(timer)}
      {warning && timer > 0 && (
        <span style={{ marginLeft: 8, fontSize: 14, color: '#dc2626' }}>
          (Hurry up!)
        </span>
      )}
    </div>
  );
};

export default Timer;
